import { Dashboard } from "./_context";

export const DashboardProvider = Dashboard.Provider